import { useQuery } from '@tanstack/react-query'

import { fetchVenueBusinessInfo } from '@/lib/venue/venueBusinessInfoApi'

/**
 * M2 — 현행 사업자 정보 + 대기중 요청 + 최근 반려 사유 조회(#1191, 백엔드 #1189 §D7).
 * 🚨 게이팅 없음 — `isError`는 진짜 조회 실패(403·404 등)만 뜻한다(`useOperationVerificationStatus`와
 * 같은 패턴).
 */
export function useVenueBusinessInfo(venueId: string) {
  return useQuery({
    queryKey: ['venue', venueId, 'business-info'] as const,
    queryFn: () => fetchVenueBusinessInfo(venueId),
  })
}
